import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

const SubscriptionModalBanner = () => {
  const theme = useContext(ThemeContext);
  return (
    <svg width="344" height="184" viewBox="0 0 344 184" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_4030_40763)">
        <rect
          x="159.191"
          y="12.1915"
          width="161.617"
          height="111.447"
          rx="2.10638"
          fill="white"
          stroke="#F4F4F4"
          strokeWidth="0.382979"
        />
        <rect
          opacity="0.6"
          x="168.191"
          y="23.4893"
          width="31.7872"
          height="3.44681"
          rx="1.7234"
          fill="url(#paint0_linear_4030_40763)"
        />
        <rect
          x="175.086"
          y="108.128"
          width="4.59574"
          height="4.59574"
          rx="1.53192"
          fill="url(#paint1_linear_4030_40763)"
        />
        <rect
          opacity="0.4"
          x="181.98"
          y="109.277"
          width="16.8511"
          height="2.29787"
          rx="1.14894"
          fill="url(#paint2_linear_4030_40763)"
        />
        <rect
          x="204.958"
          y="108.128"
          width="4.59574"
          height="4.59574"
          rx="1.53192"
          fill="url(#paint3_linear_4030_40763)"
        />
        <rect
          opacity="0.4"
          x="211.852"
          y="109.277"
          width="16.8511"
          height="2.29787"
          rx="1.14894"
          fill="url(#paint4_linear_4030_40763)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M169.725 67.5345C169.725 51.6402 181.827 38.5725 197.319 37.0432C198.282 36.9481 199.089 37.7257 199.089 38.6932V50.7976C199.089 51.6832 198.407 52.4105 197.536 52.5741C190.481 53.9001 185.143 60.0939 185.143 67.5345C185.143 72.9713 187.993 77.7424 192.28 80.4352C193.069 80.9303 193.432 81.9257 193.039 82.7693L187.955 93.6713C187.556 94.5277 186.533 94.899 185.703 94.4461C176.183 89.2482 169.725 79.1455 169.725 67.5345Z"
          fill="url(#paint5_linear_4030_40763)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M190.311 94.4166C189.892 95.3152 190.326 96.3847 191.273 96.677C194.132 97.5589 197.169 98.0337 200.318 98.0337C217.24 98.0337 230.959 84.3153 230.959 67.3928C230.959 51.4985 218.857 38.4307 203.364 36.9014C202.402 36.8064 201.594 37.584 201.594 38.5514V50.6559C201.594 51.5414 202.277 52.2687 203.147 52.4323C210.202 53.7584 215.541 59.9522 215.541 67.3928C215.541 75.8001 208.725 82.6156 200.318 82.6156C199.358 82.6156 198.418 82.5268 197.508 82.3568C196.684 82.203 195.83 82.5812 195.476 83.341L190.311 94.4166Z"
          fill="url(#paint6_linear_4030_40763)"
        />
        <rect
          opacity="0.6"
          x="247.852"
          y="23.4893"
          width="31.7872"
          height="3.44681"
          rx="1.7234"
          fill="url(#paint7_linear_4030_40763)"
        />
        <rect
          x="254.745"
          y="108.128"
          width="4.59574"
          height="4.59574"
          rx="1.53192"
          fill="url(#paint8_linear_4030_40763)"
        />
        <rect
          opacity="0.4"
          x="261.639"
          y="109.277"
          width="16.8511"
          height="2.29787"
          rx="1.14894"
          fill="url(#paint9_linear_4030_40763)"
        />
        <rect
          x="284.617"
          y="108.128"
          width="4.59574"
          height="4.59574"
          rx="1.53192"
          fill="url(#paint10_linear_4030_40763)"
        />
        <rect
          opacity="0.4"
          x="291.511"
          y="109.277"
          width="16.8511"
          height="2.29787"
          rx="1.14894"
          fill="url(#paint11_linear_4030_40763)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M249.384 67.5345C249.384 51.6402 261.486 38.5724 276.978 37.0431C277.941 36.9481 278.748 37.7257 278.748 38.6931V50.7976C278.748 51.6831 278.066 52.4104 277.196 52.574C270.14 53.9001 264.802 60.0939 264.802 67.5345C264.802 72.9713 267.652 77.7424 271.94 80.4352C272.728 80.9303 273.092 81.9256 272.698 82.7693L267.615 93.6713C267.215 94.5277 266.192 94.8989 265.363 94.4461C255.842 89.2481 249.384 79.1455 249.384 67.5345Z"
          fill="url(#paint12_linear_4030_40763)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M269.971 94.4166C269.552 95.3152 269.985 96.3847 270.933 96.6769C273.791 97.5588 276.829 98.0336 279.977 98.0336C296.899 98.0336 310.618 84.3152 310.618 67.3927C310.618 51.4984 298.516 38.4307 283.024 36.9014C282.061 36.8063 281.254 37.5839 281.254 38.5514V50.6558C281.254 51.5414 281.936 52.2687 282.806 52.4323C289.862 53.7583 295.2 59.9521 295.2 67.3927C295.2 75.8001 288.384 82.6156 279.977 82.6156C279.017 82.6156 278.078 82.5267 277.167 82.3568C276.343 82.203 275.489 82.5812 275.135 83.3409L269.971 94.4166Z"
          fill="url(#paint13_linear_4030_40763)"
        />
        <mask
          id="mask0_4030_40763"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="159"
          y="12"
          width="162"
          height="112"
        >
          <rect
            x="159.191"
            y="12.1915"
            width="161.617"
            height="111.447"
            rx="2.10638"
            fill="white"
            stroke="#F4F4F4"
            strokeWidth="0.382979"
          />
        </mask>
        <g mask="url(#mask0_4030_40763)">
          <g opacity="0.2" filter="url(#filter1_f_4030_40763)">
            <rect x="148" y="27" width="62" height="107" rx="3.14932" fill="url(#paint14_linear_4030_40763)" />
          </g>
        </g>
      </g>
      <g filter="url(#filter2_d_4030_40763)">
        <rect x="24" y="32" width="176.362" height="116" rx="3.14932" fill="url(#paint15_linear_4030_40763)" />
        <rect
          x="36.2695"
          y="45.3848"
          width="51.3077"
          height="5.57692"
          rx="2.78846"
          fill="url(#paint16_linear_4030_40763)"
        />
        <g opacity="0.2" filter="url(#filter3_d_4030_40763)">
          <circle cx="75.4391" cy="80.8141" r="12.5973" fill="white" />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M76.6356 80.5416C77.5584 80.0963 78.1951 79.1517 78.1951 78.0585C78.1951 76.5365 76.9613 75.3028 75.4394 75.3028C73.9175 75.3028 72.6838 76.5365 72.6838 78.0585C72.6838 79.1516 73.3203 80.0962 74.243 80.5415C72.6759 81.0464 71.5421 82.5166 71.5421 84.2516C71.5421 86.4039 79.3363 86.4039 79.3363 84.2516C79.3363 82.5167 78.2026 81.0466 76.6356 80.5416Z"
          fill="white"
        />
        <g opacity="0.2" filter="url(#filter4_d_4030_40763)">
          <circle cx="148.923" cy="80.8141" r="12.5973" fill="white" />
        </g>
        <path
          d="M151.194 74.7572C151.299 74.475 151.698 74.475 151.802 74.7572L152.57 76.8325C152.603 76.9213 152.673 76.9912 152.762 77.0241L154.837 77.792C155.119 77.8964 155.119 78.2957 154.837 78.4001L152.762 79.168C152.673 79.2009 152.603 79.2708 152.57 79.3596L151.802 81.4349C151.698 81.7171 151.299 81.7171 151.194 81.4349L150.426 79.3596C150.394 79.2708 150.324 79.2009 150.235 79.168L148.16 78.4001C147.877 78.2957 147.877 77.8964 148.16 77.792L150.235 77.0241C150.324 76.9912 150.394 76.9213 150.426 76.8325L151.194 74.7572Z"
          fill="white"
        />
        <path
          d="M146.655 80.05C146.76 79.7678 147.159 79.7678 147.263 80.05L148.031 82.1254C148.064 82.2141 148.134 82.2841 148.223 82.3169L150.298 83.0848C150.58 83.1893 150.58 83.5885 150.298 83.6929L148.223 84.4608C148.134 84.4937 148.064 84.5637 148.031 84.6524L147.263 86.7277C147.159 87.0099 146.76 87.0099 146.655 86.7277L145.887 84.6524C145.855 84.5637 145.785 84.4937 145.696 84.4608L143.621 83.6929C143.338 83.5885 143.338 83.1893 143.621 83.0848L145.696 82.3169C145.785 82.2841 145.855 82.2141 145.887 82.1254L146.655 80.05Z"
          fill="white"
        />
        <path
          d="M66.1721 105.881V112.81H65.0069V107.204L63.3797 108.254L62.8443 107.382L65.1013 105.881H66.1721ZM68.4351 112.81V111.298H69.6633V112.81H68.4351ZM75.4713 112.81H71.0098V111.812L72.7209 110.049C73.2388 109.517 73.6027 109.1 73.8127 108.799C74.0226 108.498 74.1276 108.17 74.1276 107.813C74.1276 107.449 74.0261 107.19 73.8232 107.036C73.6202 106.882 73.2878 106.805 72.8259 106.805C72.392 106.805 71.9126 106.854 71.3877 106.952L71.1252 106.994L71.0518 106.07C71.7306 105.867 72.434 105.766 73.1618 105.766C74.6105 105.766 75.3348 106.409 75.3348 107.697C75.3348 108.201 75.2229 108.638 74.9989 109.009C74.782 109.38 74.39 109.828 73.8232 110.353L72.343 111.791H75.4713V112.81ZM81.2615 105.881V106.91H78.0492L77.8708 108.736C78.3467 108.519 78.8156 108.411 79.2775 108.411C80.7612 108.411 81.503 109.104 81.503 110.49C81.503 111.273 81.2965 111.875 80.8836 112.295C80.4777 112.715 79.9003 112.925 79.1515 112.925C78.8366 112.925 78.4796 112.894 78.0807 112.831C77.6818 112.775 77.3634 112.719 77.1254 112.663L76.7685 112.568L76.8945 111.686C77.7203 111.826 78.4272 111.896 79.015 111.896C79.4209 111.896 79.7359 111.784 79.9598 111.56C80.1838 111.336 80.2958 111.018 80.2958 110.605C80.2958 110.192 80.1978 109.895 80.0018 109.713C79.8059 109.531 79.5504 109.44 79.2355 109.44C78.6686 109.44 78.2067 109.51 77.8498 109.65L77.6608 109.723L76.926 109.566L77.1149 105.881H81.2615ZM83.0207 106.616C83.4616 106.049 84.1194 105.766 84.9942 105.766C85.869 105.766 86.5234 106.046 86.9573 106.605C87.3912 107.165 87.6082 108.093 87.6082 109.387C87.6082 110.675 87.3877 111.588 86.9468 112.127C86.5129 112.659 85.8585 112.925 84.9837 112.925C84.1159 112.925 83.4616 112.659 83.0207 112.127C82.5867 111.595 82.3698 110.686 82.3698 109.398C82.3698 108.103 82.5867 107.176 83.0207 106.616ZM86.0755 107.361C85.8585 106.976 85.4981 106.784 84.9942 106.784C84.4903 106.784 84.1264 106.976 83.9025 107.361C83.6855 107.739 83.577 108.408 83.577 109.366C83.577 110.325 83.689 110.99 83.913 111.361C84.1439 111.725 84.5043 111.907 84.9942 111.907C85.4911 111.907 85.848 111.725 86.065 111.361C86.2889 110.99 86.4009 110.325 86.4009 109.366C86.4009 108.408 86.2924 107.739 86.0755 107.361Z"
          fill="white"
        />
        <rect
          opacity="0.8"
          x="50.7698"
          y="122.346"
          width="51.3077"
          height="3.34615"
          rx="1.67308"
          fill="url(#paint17_linear_4030_40763)"
        />
        <path
          d="M144.354 112.81H139.892V111.812L141.603 110.049C142.121 109.517 142.485 109.1 142.695 108.799C142.905 108.498 143.01 108.17 143.01 107.813C143.01 107.449 142.908 107.19 142.705 107.036C142.502 106.882 142.17 106.805 141.708 106.805C141.274 106.805 140.795 106.854 140.27 106.952L140.007 106.994L139.934 106.07C140.613 105.867 141.316 105.766 142.044 105.766C143.493 105.766 144.217 106.409 144.217 107.697C144.217 108.201 144.105 108.638 143.881 109.009C143.664 109.38 143.272 109.828 142.705 110.353L141.225 111.791H144.354V112.81ZM148.601 112.81V111.571H145.483V110.679L147.309 105.881H148.601L146.669 110.553H148.601V108.516H149.776V110.553H150.532V111.571H149.776V112.81H148.601ZM153.541 111.907C154.604 111.907 155.143 111.235 155.157 109.891L154.905 109.975C154.373 110.157 153.946 110.248 153.625 110.248C152.869 110.248 152.291 110.07 151.892 109.713C151.493 109.349 151.294 108.806 151.294 108.086C151.294 107.365 151.514 106.798 151.955 106.385C152.403 105.972 153.009 105.766 153.772 105.766C154.646 105.766 155.297 106.077 155.724 106.7C156.151 107.323 156.364 108.243 156.364 109.461C156.364 110.679 156.123 111.56 155.64 112.106C155.164 112.652 154.464 112.925 153.541 112.925C153.016 112.925 152.449 112.862 151.84 112.736L151.535 112.673L151.64 111.76C152.319 111.858 152.953 111.907 153.541 111.907ZM153.719 109.219C154.118 109.219 154.527 109.142 154.947 108.988L155.168 108.915C155.154 107.494 154.688 106.784 153.772 106.784C153.373 106.784 153.061 106.899 152.837 107.13C152.613 107.361 152.501 107.676 152.501 108.075C152.501 108.838 152.907 109.219 153.719 109.219Z"
          fill="white"
        />
        <rect
          opacity="0.8"
          x="127.73"
          y="122.346"
          width="42.3846"
          height="3.34615"
          rx="1.67308"
          fill="url(#paint18_linear_4030_40763)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_4030_40763"
          x="136.909"
          y="0.954545"
          width="206.182"
          height="156.012"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="11.0455" />
          <feGaussianBlur stdDeviation="11.0455" />
          <feColorMatrix type="matrix" values={theme.colors.backgroundShadowGradientValue} />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4030_40763" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4030_40763" result="shape" />
        </filter>
        <filter
          id="filter1_f_4030_40763"
          x="128"
          y="7"
          width="102"
          height="147"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="10" result="effect1_foregroundBlur_4030_40763" />
        </filter>
        <filter
          id="filter2_d_4030_40763"
          x="0"
          y="20"
          width="224.362"
          height="164"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="12" />
          <feGaussianBlur stdDeviation="12" />
          <feColorMatrix type="matrix" values={theme.colors.backgroundShadowGradientValue} />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4030_40763" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4030_40763" result="shape" />
        </filter>
        <filter
          id="filter3_d_4030_40763"
          x="46.0454"
          y="55.6195"
          width="58.7873"
          height="58.7873"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4.1991" />
          <feGaussianBlur stdDeviation="8.39819" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.222444 0 0 0 0 0 0 0 0 0 0.433333 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4030_40763" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4030_40763" result="shape" />
        </filter>
        <filter
          id="filter4_d_4030_40763"
          x="119.53"
          y="55.6195"
          width="58.7873"
          height="58.7873"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4.1991" />
          <feGaussianBlur stdDeviation="8.39819" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.222444 0 0 0 0 0 0 0 0 0 0.433333 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4030_40763" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4030_40763" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_4030_40763"
          x1="177.526"
          y1="24.6382"
          x2="222.2"
          y2="26.4117"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2D2D2D" />
          <stop offset="1" stopColor="#2D2D2D" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4030_40763"
          x1="181.05"
          y1="111.096"
          x2="178.877"
          y2="105.51"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={theme.colors.graph[3]} />
          <stop offset="1" stopColor={theme.colors.graph[3]} stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4030_40763"
          x1="186.929"
          y1="110.043"
          x2="210.625"
          y2="110.791"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2D2D2D" />
          <stop offset="1" stopColor="#2D2D2D" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_4030_40763"
          x1="209.17"
          y1="111.654"
          x2="207.599"
          y2="107.564"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={theme.colors.graph[8]} />
          <stop offset="1" stopColor={theme.colors.graph[8]} stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_4030_40763"
          x1="216.8"
          y1="110.043"
          x2="240.496"
          y2="110.791"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2D2D2D" />
          <stop offset="1" stopColor="#2D2D2D" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_4030_40763"
          x1="207.831"
          y1="74.234"
          x2="168.959"
          y2="23.2978"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={theme.colors.graph[3]} />
          <stop offset="1" stopColor={theme.colors.graph[3]} stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_4030_40763"
          x1="227.554"
          y1="83.8084"
          x2="200.554"
          y2="36.8936"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={theme.colors.graph[8]} />
          <stop offset="1" stopColor={theme.colors.graph[8]} stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_4030_40763"
          x1="257.186"
          y1="24.6382"
          x2="301.86"
          y2="26.4117"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2D2D2D" />
          <stop offset="1" stopColor="#2D2D2D" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_4030_40763"
          x1="260.709"
          y1="111.096"
          x2="258.536"
          y2="105.51"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={theme.colors.graph[3]} />
          <stop offset="1" stopColor={theme.colors.graph[3]} stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_4030_40763"
          x1="266.587"
          y1="110.043"
          x2="290.283"
          y2="110.791"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2D2D2D" />
          <stop offset="1" stopColor="#2D2D2D" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_4030_40763"
          x1="288.829"
          y1="111.654"
          x2="287.258"
          y2="107.564"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={theme.colors.graph[8]} />
          <stop offset="1" stopColor={theme.colors.graph[8]} stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_4030_40763"
          x1="296.459"
          y1="110.043"
          x2="320.156"
          y2="110.791"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2D2D2D" />
          <stop offset="1" stopColor="#2D2D2D" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_4030_40763"
          x1="287.49"
          y1="74.2339"
          x2="248.618"
          y2="23.2978"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={theme.colors.graph[3]} />
          <stop offset="1" stopColor={theme.colors.graph[3]} stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_4030_40763"
          x1="307.213"
          y1="83.8084"
          x2="280.213"
          y2="36.8935"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={theme.colors.graph[8]} />
          <stop offset="1" stopColor={theme.colors.graph[8]} stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_4030_40763"
          x1="170.286"
          y1="142.231"
          x2="242.863"
          y2="98.3596"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={theme.colors.primary.c400} />
          <stop offset="1" stopColor={theme.colors.graph[3]} />
        </linearGradient>
        <linearGradient
          id="paint15_linear_4030_40763"
          x1="73"
          y1="83"
          x2="161.363"
          y2="30.4337"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={theme.colors.primary.c400} />
          <stop offset="1" stopColor={theme.colors.graph[3]} />
        </linearGradient>
        <linearGradient
          id="paint16_linear_4030_40763"
          x1="35.7118"
          y1="48.638"
          x2="102.584"
          y2="51.9816"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_4030_40763"
          x1="50.2121"
          y1="124.298"
          x2="116.789"
          y2="129.846"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_4030_40763"
          x1="127.27"
          y1="124.298"
          x2="182.389"
          y2="128.092"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default SubscriptionModalBanner;
